<template>
  <div class="so-skeleton" v-bind="$attrs">
    <v-sheet
      v-if="type === 'default'"
      :height="height"
      :width="width"
      class="so-skeleton__default v-skeleton-loader__bone rounded"
      data-testid="so-skeleton-default"
    >
      &nbsp;
    </v-sheet>
    <v-skeleton-loader
      v-else
      :width="width"
      :height="height"
      :type="type"
      data-testid="so-skeleton"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"

  type SkeletonType =
    | "default"
    | "image"
    | "avatar"
    | "button"
    | "card"
    | "list-item"
    | "list-item-avatar"
    | "list-item-avatar-two-line"
    | "list-item-two-line"
    | "list-item-three-line"
    | "table"
    | "text"

  export default defineComponent({
    inheritAttrs: false,
    props: {
      type: {
        type: [String, Array] as PropType<SkeletonType | SkeletonType[]>,
        default: "default",
      },
      width: {
        type: [String, Number],
        default: undefined,
      },
      height: {
        type: [String, Number],
        default: undefined,
      },
    },
  })
</script>
<style>
  .so-skeleton {
    font-size: inherit;
    cursor: progress;
  }

  .so-skeleton__default {
    font-size: inherit;
    background: rgba(var(--v-theme-on-surface), var(--v-border-opacity));
  }
</style>
